<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--project">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">プロジェクトの一覧</div>
        </div>

        <a class="c-btn c-btn--blue u-w250" @click="onClickAddProject">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#plus" />
            </svg>
          </div>
          <p class="c-btn__text">プロジェクトを追加する</p>
        </a>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- プロジェクトの一覧 -->
      <div class="l-main-content">
        <div class="p-project-block">
          <ul class="p-project-list">
            <!-- プロジェクト情報 -->
            <li
              v-for="(project, loopIndex1) in projects"
              :key="loopIndex1"
              class="p-project-list__item"
              @click="onClickProject(project.serviceId)"
            >
              <!-- プロジェクト見出し -->
              <div class="p-project__head">
                <div class="c-title u-w100p">
                  <div class="c-title__text u-w340 u-text-ellipsis">{{ project.name }}</div>
                  <div class="c-title__btns u-w130">
                    <span
                      v-show="isSystemAdminEdit()"
                      class="c-btn c-btn--white c-btn--circle"
                      @click.stop="onClickCopyToClipboardServiceId(project.serviceId)"
                      @mouseout="onMouseoutHideCopyFinish"
                    >
                      <div v-show="copyFinish" class="c-btn__text c-btn__text--balloon" style="z-index: 2000;">コピーしました！</div>
                      <div class="c-btn__text c-btn__text--balloon">IDコピー</div>
                      <div class="c-icon c-icon--gray-3 u-wh20">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#clipboard" />
                        </svg>
                      </div>
                    </span>
                    <a class="c-btn c-btn--white c-btn--circle" @click.stop="onClickEditProject(project.editUrl)">
                      <div class="c-btn__text c-btn__text--balloon">編集する</div>
                      <div class="c-icon c-icon--gray-3 u-wh20">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#edit" />
                        </svg>
                      </div>
                    </a>
                    <a class="c-btn c-btn--white c-btn--circle" @click.stop="onClickDeleteProject(project.serviceId, project.name)">
                      <div class="c-btn__text c-btn__text--balloon">削除する</div>
                      <div class="c-icon c-icon--gray-3 u-wh20">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#trash" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <!-- /プロジェクト見出し -->
              <!-- プロジェクトデータ -->
              <div class="p-project__data">
                <div class="c-url">
                  <div v-show="isSystemAdminEdit()" class="p-project__label">プロジェクトID: {{ project.serviceId }}</div>
                  <div v-show="isSystemAdminEdit()" class="p-project__label">senderID: {{ project.senderId }}</div>
                  <div class="c-url__text">{{ project.defaultUrl }}</div>
                </div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li v-for="(typeName, loopIndex2) in project.types" :key="loopIndex2" class="c-tag-list__item c-tag-list__item--green">{{ typeName }}</li>
                  </ul>
                </div>
                <div v-show="project.types.includes('ブラウザ')" class="p-project__label">現在のオプトイン数</div>
                <div v-show="project.types.includes('ブラウザ')" class="c-metrics c-metrics--text">
                  <div class="c-metrics-text">
                    <span class="c-metrics-text__value">{{ project.optinCount }}</span>
                    <span class="c-metrics-text__diff">前回からの増加数</span>
                    <span class="c-metrics-text__diff-value">{{ project.optinCountDelta }}</span>
                  </div>
                </div>
              </div>
              <!-- /プロジェクトデータ -->
              <!-- プロジェクトフッター -->
              <div class="p-project__foot">
                <div class="c-proposal">
                  <div class="c-icon c-icon--blue-2 u-wh28">
                  </div>
                </div>
              </div>
              <!-- /プロジェクトフッター -->
            </li>
          </ul>
        </div>
        <div ref="observeElement"> </div>
      </div>
      <!-- /プロジェクトの一覧 -->
    </main>
    <!-- /メインコンテンツエリア -->

    <!-- モーダル: プロジェクト削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--project-delete"
      title="以下のプロジェクトを削除してもよろしいですか?"
      :body="`${deleteProjectName}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteProject
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
  <!-- /ページ内容 -->
</template>

<script>
import axios from 'axios';
import store from '../../funcs/store.js';
export default {
  props: {
    projectData: Object,
    linkUrl: String,
    linkText: String,
  },
  data () {
    return {
      projects: null,
      errorMessage: '',
      deleteProjectName: '',
      deleteProjectServiceId: '',
      isDeleteProject: false,
      isError: false,
      copyFinish: false,
      currentPage: 2,
      lastPage: 1,
      observer: null,
    }
  },
  mounted() {
    this.projects = this.projectData['projects'];
    if (this.projects.length == 0) {
      this.isError = true;
      this.errorMessage = 'アクセスできるプロジェクトがありません。<br>プロジェクトを新規作成してください。<br>ご質問がございましたら弊社カスタマサポートチーム（<a style="text-decoration: underline; color: blue;" href="mailto:support@signity.jp">support@signity.jp</a>）へご連絡ください。';
    }

    this.lastPage = this.projectData.pagination.last_page;

    // 無限スクロールの監視
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (this.currentPage <= this.lastPage && (entry && entry.isIntersecting)) {
        this.onScrollMouse();
      }
    });
    const observeElement = this.$refs.observeElement;
    this.observer.observe(observeElement);
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: プロジェクトカード要素
    onClickProject: function (serviceId) {
      const MAX_RETRIES = 3;
      const data = {
        service_id: serviceId,
      };

      const self = this;
      // サービスのセット
      function selectService(data, retryCount = 0) {
        axios
          .post("/api/system/service", data)
          .then((res) => {
            if (res.data.result == "OK") {
              if (res.data.service_id == serviceId) {
                location.href = "/coins-admin";
              } else {
                if (retryCount < MAX_RETRIES) {
                  setTimeout(() => selectService(data, retryCount + 1), 1000);
                } else {
                  self.isError = true;
                  self.errorMessage = 'エラーが発生しました';
                }
              }
            } else {
              self.isError = true;
              self.errorMessage = '指定サイト情報が存在しません';
            }
          })
          .catch((error) => {
            self.isError = true;
            self.errorMessage = '指定サイト情報が存在しません';
            self.handleHttpError(error);
          });
      }

      selectService(data);
    },

    // クリック: プロジェクト作成ボタン
    onClickAddProject: function() {
      location.href = '/coins-admin/project/edit/new';
    },

    // クリック: プロジェクト編集ボタン
    onClickEditProject: function(editUrl) {
      location.href = editUrl;
    },

    // クリック: プロジェクト削除ボタン
    onClickDeleteProject: function (serviceId, name) {
      if (store.state.service.selecteServiceId == serviceId) {
        alert('選択中のプロジェクトは削除できません');
        return;
      }
      this.isDeleteProject = true;
      this.deleteProjectName = name;
      this.deleteProjectServiceId = serviceId;
    },

    // クリック: プロジェクトIDコピーボタン
    onClickCopyToClipboardServiceId: function (serviceId) {
      navigator.clipboard.writeText(serviceId)
        .then(() => {
          this.copyFinish = true;
        })
        .catch(e => {
          console.error(e)
        })
    },

    onScrollMouse() {
      axios.get(`/api/project/getListPage/${this.currentPage}`)
        .then((res) => {
          this.projects = [...this.projects, ...res.data.projects];
          this.currentPage = res.data.pagination.current_page;
          this.currentPage++;
        })
        .catch((_error) => {
        });
    },

    // マウスアウト: コピー完了バルーン非表示
    onMouseoutHideCopyFinish: function () {
      this.copyFinish = false;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteProject = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal(_serviceId,_serviceName) {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      axios.delete('/api/projects/' + this.deleteProjectServiceId)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          location.href = '/coins-admin/project/list';
        })
        .catch(e => {
          const message = (
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors['serviceId']
          ) ? e.response.data.errors['serviceId'][0] : 'プロジェクトの削除に失敗しました' ;
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage(message);
        });
    },
    isSystemAdminEdit() {
      return store.state.user.isSystemAdminEdit;
    },
  },
}
</script>
